import {CloseButton} from '@headlessui/react'
import {useTranslation} from 'react-i18next'

import {Button, DialogNew} from '@sdox/ui'
import {useCurrentContactPerson} from '@sdox/api'

import {ContactHeader} from './ContactHeader'
import {ContactInfoRows} from './ContactInfoRows'
import {ContactInfoButtons} from './ContactInfoButtons'
import {VCardButton} from '../../VCardButton'

import type {CustomerContentProps} from '../../CustomerContent'

export interface ContactCardProps extends CustomerContentProps {
  isOpen: boolean
  onClose: () => void
}

export const ContactCard = (props: ContactCardProps) => {
  const {isOpen, onClose} = props
  const contactPerson = useCurrentContactPerson()
  const {t} = useTranslation()

  if (!contactPerson) return null

  return (
    <DialogNew
      open={isOpen}
      onClose={onClose}
      size={'small'}
      persistent={false}
      limitHeight={false}
    >
      <div className={'overflow-y-auto'}>
        <ContactHeader />
        <ContactInfoButtons />
        <ContactInfoRows />
      </div>
      <DialogNew.Footer className={'flex flex-wrap justify-end gap-spacing-12'}>
        <CloseButton
          as={Button}
          size={'medium'}
          variant={'outline'}
          className={'min-w-fit flex-1'}
        >
          {t('common:close')}
        </CloseButton>
        <VCardButton className={'min-w-fit flex-1'} />
      </DialogNew.Footer>
    </DialogNew>
  )
}
